import React, { useState } from "react";
import { connect } from "react-redux";
import shortid from "shortid";
import { set } from "dot-prop-immutable";
import { getParentFormWidthChildren } from "@whalecloud/page-builder-core/selectors";
import { Table, Icon } from '@whalecloud/fdx';
import { characterShortId } from "@whalecloud/page-builder-core/utils/elementUtils";
import { getLocale } from '@utils/util';

const DefaultValueTable = (props: any) => {
  const messages = getLocale();
  
  const { formElement, updateElement, element } = props;
  const { data: { formItemSettings = [], formSettings = {} } = {} } = element;
  const {
    defaultValue,
  } = formItemSettings;

  const { name } = formSettings;

  characterShortId(shortid);

  const uuid = () => shortid.generate();

  let defaultValueArr = []

  if (defaultValue && Array.isArray(defaultValue)) {
    defaultValueArr = defaultValue.map(val => {
      val.key = uuid();
      return val
    })
  } else if (defaultValue) {
    defaultValue.key = uuid()
    defaultValueArr.push(defaultValue)
  }

  const [dataSource, setDataSource] = useState(defaultValueArr || []);
  const [editingKey, setEditingKey] = useState('');
  const [addRowState, setAddRowState] = useState(false);
  const columns = [
    {
      title: messages['PAGEBUIDER_SETTINGS_NAME'],
      dataIndex: "name",
      width: '45%',
      editable: true,
      editRules: [{ required: true, message: messages['PAGEBUIDER_SETTINGS_PLEASE_INPUT_NAME'] }]
    },
    {
      title: messages['PAGEBUIDER_SETTINGS_VALUE'],
      dataIndex: "value",
      width: '35%',
      editable: true,
      editRules: [{ required: true, message: messages['PAGEBUIDER_SETTINGS_PLEASE_INPUT_VALUE'] }]
    },
    {
      title: messages['PAGEBUIDER_SETTINGS_OPERATION'],
      dataIndex: "edit",
      width: '20%',
      editable: true,
      render: (text, record) => <a onClick={() => { delRow(record.key) }}><Icon type="delete" /></a>,
      editContent: () => <Icon type="edit" />,
      saveContent: () => <Icon type="save" />,
      cancelContent: () => <Icon type="stop" />
    }
  ];
  const delRow = key => {
    const newData = dataSource.filter(item => item.key !== key);
    setDataSource(newData)
    hanldeEleUpdate(newData)
  }

  const addRow = () => {
    const id = uuid();
    const data = dataSource.concat({
      key: id,
      name: '',
      value: '',
    });
    setDataSource(data);
    setEditingKey(id);
    setAddRowState(true);
  };

  const onSaveRowEdit = (record, newData) => {
    setDataSource(newData);
    setEditingKey('');
    hanldeEleUpdate(newData);
  }

  const onCancelRowEdit = () => {
    if (addRowState) {
      dataSource.pop()
      setDataSource([...dataSource]);
      hanldeEleUpdate([...dataSource]);
    }
    setAddRowState(false);
  }

  const handleInitialValues = (value:any) => {
    if (formElement) {
      const propName = `data.formSettings.initialValues.${name}`
      const newElement = set(formElement, propName, value);
      updateElement({
        element: newElement,
      });
    }
  }

  const hanldeEleUpdate = (elements) => {
    let newDefaultnArr;
    if (elements.length > 1) {
      newDefaultnArr = elements.map(ele => {
        const eleObj = {};
        Object.keys(ele).forEach(key => {
          if (key !== 'key') {
            eleObj[key] = ele[key]
          }
        })
        return eleObj
      })
    } else {
      newDefaultnArr = elements[0];
    }
    handleInitialValues(newDefaultnArr);
    const newElement = set(element, 'data.formItemSettings.defaultValue', newDefaultnArr);
    updateElement({
      element: newElement,
    });
  }

  const footer = () => <a onClick={addRow}>{messages['PAGEBUIDER_SETTINGS_ADD_NEW_ITEM']}</a>;
  return (
    <div>
      <Table
        columns={columns}
        dataSource={dataSource}
        scroll={{ y: 240 }}
        editRow
        editingKey={editingKey}
        onSaveRowEdit={onSaveRowEdit}
        onCancelRowEdit={onCancelRowEdit}
        footer={footer}
        className="formbuild-setting-table"
      />
    </div>
  );
}

export default connect<any, any, any>((state, { element }) => {
  return {
    formElement: element ? getParentFormWidthChildren(state, element.id) : null
  }
})(DefaultValueTable);
